import { useMemo } from 'react';
import { useRestPostQuery } from 'utils/hooks/api/useRestPostQuery';
import { BaseLevelSnippetsAPIRequest, BaseLevelSnippetsAPIResp } from '../../types';

const BASE_LEVEL_SNIPPETS_URL = '/analytics/snippets/baseLevel';
const DEFAULT_INFO = {
  count: 0,
  offset: 0,
  limit: 10,
  page: 1,
};

export const useQueryBaseLevelSnippets = ({
  campaignIds,
  startTime,
  endTime,
  sort,
  pagination,
  searchOpt,
  templateIdOpt,
}: BaseLevelSnippetsAPIRequest) => {
  const { sortBy, sortDirection } = sort;
  const { limit, offset } = pagination;

  const params = useMemo(
    () => ({
      campaignIds,
      startTime,
      endTime,
      sort,
      pagination,
      searchOpt,
      templateIdOpt,
    }),
    [
      campaignIds,
      startTime,
      endTime,
      sortBy,
      sortDirection,
      limit,
      offset,
      searchOpt,
      templateIdOpt,
    ],
  );

  const {
    data,
    isError: hasBaseLevelDataError,
    isLoading,
  } = useRestPostQuery<BaseLevelSnippetsAPIResp>(BASE_LEVEL_SNIPPETS_URL, params, {
    enabled: campaignIds.length > 0 && !!startTime && !!endTime,
  });

  return {
    baseLevelSnippetData: data?.results || [],
    info: data?.info || DEFAULT_INFO,
    baseLevelSnippetsLoading: isLoading,
    hasBaseLevelDataError,
  };
};
